export class PasswordChangeRequest {
    userID: number = 0;
    password: string = "";
    newPassword: string = "";
    repeatPassword: string = "";
}